
(() => {
  const confirmationSelector = '[data-customer-type-confirmation]';
  const optionSelector = '[data-customer-type-option]';
  const checkoutSelector = '[data-customer-type-checkout]';

  let confirmedSelection = null;
  let saving = false;

  function cartRoot() {
    return (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  }

  function updateUI() {
    document.querySelectorAll(confirmationSelector).forEach(box => {
      const value = confirmedSelection !== null
        ? confirmedSelection
        : (box.dataset.selectedType || '');

      const current = box.querySelector('[data-customer-type-current]');
      const options = box.querySelector('[data-customer-type-options]');
      const change = box.querySelector('[data-customer-type-change]');

      if (current && current.textContent.trim() !==
          (value || 'Please select an option')) {
        current.textContent = value || 'Please select an option';
      }

      if (options) options.hidden = Boolean(value);
      if (change) change.hidden = !value;

      box.dataset.selectedType = value;
    });

    document.querySelectorAll(checkoutSelector).forEach(button => {
   const box = document.querySelector(confirmationSelector);

      const value = confirmedSelection !== null
        ? confirmedSelection
        : (box?.dataset.selectedType || '');

      button.disabled =
        saving ||
        button.dataset.cartEmpty === 'true' ||
        !value;
    });

    document.querySelectorAll(optionSelector).forEach(button => {
      button.disabled = saving;
    });
  }

  async function saveCustomerType(value) {
    if (!value || saving) return;

    saving = true;

    document.querySelectorAll('[data-customer-type-status]')
      .forEach(status => {
        status.textContent = 'Saving your selection…';
      });

    updateUI();

    try {
      const response = await fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            customer_type: value
          }
        })
      });

      if (!response.ok) {
        throw new Error('Cart update failed: ' + response.status);
      }

      await response.json();

      confirmedSelection = value;

      document.querySelectorAll('[data-customer-type-status]')
        .forEach(status => {
          status.textContent = '';
        });

    } catch (error) {
      console.error('Unable to save customer type:', error);

      document.querySelectorAll('[data-customer-type-status]')
        .forEach(status => {
          status.textContent =
            'We could not save your selection. Please try again.';
        });
    } finally {
      saving = false;
      updateUI();
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const change = event.target.closest('[data-customer-type-change]');

    if (change) {
      event.preventDefault();

      const box = change.closest(confirmationSelector);
      const options = box?.querySelector('[data-customer-type-options]');

      if (options) options.hidden = false;
      change.hidden = true;
      return;
    }

    const option = event.target.closest(optionSelector);

    if (option) {
      event.preventDefault();
      saveCustomerType(option.dataset.customerTypeOption);
    }
  });

  function initialise() {
    updateUI();

    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 && (
            node.matches?.(confirmationSelector + ', ' + checkoutSelector) ||
            node.querySelector?.(confirmationSelector + ', ' + checkoutSelector)
          )
        )
      );

      if (relevant) updateUI();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', updateUI);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
